module.exports = __webpack_public_path__ + "bb67afa32ca091fd20cdde21f285bc2f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Rist/content/images/news/QT_Sydney_Room_1566x486.jpg
// module id = 224
// module chunks = 0